import {isEmpty, cloneDeep} from 'lodash'
import OrganisationForm from '@/components/pages/InformationPortal/Organisation/OrganisationForm/OrganisationForm.vue'
import { locationListForEntity } from '@/libs/api/api'
import { mapGetters }  from 'vuex';
import permissions from '@/libs/constant/permissions'
import {loader} from '@/libs/helper'
export default {
    name: 'Profile',
    components: {
        OrganisationForm,
    },
    props: {
        removeOrganisation: {
            type: Function,
            default: () => {}
        },
        organisationDetails: {
            type: Object,
            default: () => {}
        },
        updateFormDataValues: {
            type: Function,
            default: () => {}
        }
    },
    async created () {
        loader(this, true)
        await this.fetchLocations(); 
        await locationListForEntity(this.$route.params.id, {child_structure: true})
        .then(response => {
            this.$store.dispatch('setLocations', (response.result || []));
        })
        .catch(error => console.error(error))
        .finally(() => {
           loader(this, false)
        });
    },
    computed: {
        organisationFormData () {
            let organisationFormData = cloneDeep(this.organisationDetails)
            const location = cloneDeep((this.locations && this.locations[0]) || {})
            if (!isEmpty(location) && isEmpty(organisationFormData.contact_detail) && isEmpty(organisationFormData.address)) {
                organisationFormData.address = cloneDeep({
                    city: location.city,
                    country_code: location.country_code,
                    country_name: location.country_name,
                    line1: location.line1,
                    line2: location.line2,
                    postal_code: location.postal_code,
                    state: location.state,
                    _id: location._id,
                })

                organisationFormData.contact_detail = cloneDeep({
                    email: location.email,
                    fax: location.fax,
                    phone: location.phone
                })
                this.updateFormDataValues({...organisationFormData})
            }
            return {...organisationFormData}
        },
        ...mapGetters({
            locations: 'getLocations',
            hasPermission: 'hasPermission'
        })
    },

    data() {
        return {
            isEmpty,
            isRename: false,
            nameLimitValidation: function (rule, value, callback) {
                if(rule.field === 'middle_name' && value.split('').length === 0 ){
                    callback();
                } else if(value.split('').length < 2){
                    callback(new Error(window.i18next.t('Minimum 2 character required')));
                } else{
                    callback();
                }
            },
            validateSlug: function (rule, value, callback) {
                // eslint-disable-next-line
                let regex = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
                let checkSpaces = /\s/g
                if (isEmpty(value) || (value && value.length > 20)) callback(new Error(window.i18next.t('Invalid screen name')))
                if (regex.test(value)) callback(new Error(window.i18next.t('Invalid screen name')))
                if (checkSpaces.test(value)) callback(new Error(window.i18next.t('Spaces are not allowed')))
                else callback()
            },
            permissions: permissions
        }
    },
    methods: {

        /**
         * close rename popup
         */
        closeRenamePopup () {
            this.isRename = false
        },

        /**
         * to fetch locations
         */
         async fetchLocations () {
            // api call
           await locationListForEntity(this.$route.params.id, {child_structure: true})
            .then(response => {
                this.$store.dispatch('setLocations', (response.result || []))
            }).catch(error => console.error(error))
        },
    }
}